/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import Text from "components/Common/Text";
import clock from "assets/clock.svg";
import PropTypes from "prop-types";
import uuid from "react-uuid";

function Circle({ fill }) {
  return (
    <div
      style={{
        width: 16,
        height: 16,
        backgroundColor: fill && "#C6C7C8",
        border: !fill && "2px solid #379FDC",
        borderRadius: 16,
        margin: 2,
      }}
    />
  );
}

function Counter({ countOfUsers, fiveSomes, matchPlay, teamsPlay }) {
  const countOpenSlots = () => {
    if (fiveSomes) {
      return 5 - countOfUsers;
    }
    if (matchPlay) {
      if (teamsPlay) {
        return 4 - countOfUsers;
      }
      return 2 - countOfUsers;
    }
    return 4 - countOfUsers;
  };

  return (
    <div
      style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
    >
      {new Array(countOfUsers).fill().map(() => (
        <Circle key={uuid()} fill />
      ))}
      {new Array(countOpenSlots()).fill().map(() => (
        <Circle key={uuid()} />
      ))}

      <Text
        as="C1"
        bold
        style={{ color: "#379FDC", textTransform: "uppercase", marginLeft: 4 }}
      >
        {countOpenSlots()} Open
      </Text>
    </div>
  );
}

function CardEvent2({
  teeTimeString,
  users,
  teams,
  onJoinTeam,
  onJoinTeeTime,
  isPlay,
  onOpenTeeTime,
  findUserInTeeTime,
  sumbitted,
  alredyPlayInDifrentTeeTime,
  fiveSomes,
  matchPlay,
}) {
  const title = sumbitted ? "SCORECARD" : "PLAY";

  const countUsersInTeeTime = () =>
    teams.length
      ? teams?.reduce((iterator, i) => iterator + i.users.length, 0)
      : users.length;

  const teamsIsFull = (teamSize, teamUsersLength, usersLength) => {
    if (fiveSomes) {
      if (teams.length) {
        return (
          (teamSize === 4 && teamUsersLength === 5) ||
          (teamSize === 2 &&
            (teamUsersLength === 3 ||
              (teamUsersLength === 2 && usersLength === 5)))
        );
      }
      return users.length === 5;
    }
    if (matchPlay) {
      return users.length === 2;
    }
    return teams.length ? teamSize === teamUsersLength : users.length === 4;
  };

  const teamsPlayButtonTitle = ({ teamSize, teamUsersLength, usersLength }) => {
    if (sumbitted) {
      return "SCORECARD";
    }
    if (!sumbitted && teamsIsFull(teamSize, teamUsersLength, usersLength)) {
      return "FULL";
    }
    return "PLAY";
  };

  const individualPlayButtonTitle = () => {
    if (sumbitted) {
      return "SCORECARD";
    }
    if (isPlay) {
      return "ENTER MATCH";
    }
    if (!isPlay && !sumbitted) {
      if (users.length === (fiveSomes ? 5 : 4)) {
        return "FULL";
      }
      if (matchPlay && users.length === 2) {
        return "FULL";
      }
    }

    if (!isPlay && alredyPlayInDifrentTeeTime) {
      return "CLOSE";
    }
    return "PLAY";
  };

  const individualIsFull =
    individualPlayButtonTitle() === "FULL" ||
    individualPlayButtonTitle() === "CLOSE";

  return (
    <div
      style={{
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
        padding: "12px 20px",
        borderRadius: 16,
        marginBottom: 20,
      }}
    >
      <div
        style={{
          height: 28,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "0.5px solid #C6C7C8",
          paddingBottom: 8,
        }}
      >
        <div style={{ display: "flex" }}>
          <img src={clock} alt="clock" />
          <Text
            as="H2"
            bold
            style={{ color: "#232C2E", marginLeft: 4, fontWeight: 600 }}
          >
            {teeTimeString}
          </Text>
        </div>
        <div>
          <Counter
            countOfUsers={countUsersInTeeTime()}
            fiveSomes={fiveSomes}
            matchPlay={matchPlay}
            teamsPlay={!!teams}
          />
        </div>
      </div>
      {teams.length ? (
        <>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {teams?.map((team, index) => {
              const usersLength = teams.reduce(
                (prev, curr) => prev + curr.users.length,
                0,
              );
              const buttonTitle = teamsPlayButtonTitle({
                teamSize: team.teamSize,
                teamUsersLength: team.users.length,
                usersLength,
              });

              const isFull = buttonTitle === "FULL";

              return (
                <div
                  key={team.teamId}
                  style={{
                    justifyContent: "inherit",
                    display: "flex",
                    flexDirection: "column",
                    // alignItems: "inherit",
                  }}
                >
                  <div
                    style={{
                      alignItems: index === 0 ? "flex-start" : "flex-end",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Text
                      as="C1"
                      mt={12}
                      style={{ color: "#379FDC", textTransform: "uppercase" }}
                    >
                      {team.name}
                    </Text>
                    <div
                      style={{
                        flexDirection: "column",
                      }}
                    >
                      {team.users.length >= 1 ? (
                        team.users?.map((teamUser) => (
                          <Text
                            mt={4}
                            style={{ color: "#232C2E" }}
                            key={teamUser.uid}
                          >
                            {teamUser?.displayName}
                          </Text>
                        ))
                      ) : (
                        <Text mt={4} style={{ color: "#232C2E" }}>
                          Empty Team
                        </Text>
                      )}
                    </div>
                  </div>
                  {!isPlay && findUserInTeeTime && (
                    <div
                      onClick={() => !isFull && onJoinTeam(team.teamId)}
                      aria-hidden
                      style={{
                        marginTop: 12,
                        backgroundColor: isFull ? "#EDEFEF" : "#379FDC",
                        borderRadius: 8,
                        width: "max-content",
                        paddingLeft: 8,
                        paddingRight: 8,
                        height: 38,
                        minWidth: 74,
                        // display: "grid",
                        // placeItems: "center",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        alignSelf: index === 1 && "flex-end",
                      }}
                    >
                      <Text
                        style={{
                          color: isFull ? "#C6C7C8" : "white",
                          fontWeight: 800,
                          fontSize: 13,
                        }}
                      >
                        {buttonTitle}
                      </Text>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          {isPlay && (
            <div
              onClick={() => onOpenTeeTime()}
              aria-hidden
              style={{
                marginTop: 12,
                backgroundColor: "#FFA340",
                borderRadius: 8,
                width: "max-content",
                paddingLeft: 8,
                paddingRight: 8,
                minWidth: 74,
                height: 38,
                display: "grid",
                placeItems: "center",
              }}
            >
              <Text
                style={{
                  color: "white",
                  fontWeight: 800,
                  fontSize: 13,
                }}
              >
                {title}
              </Text>
            </div>
          )}
        </>
      ) : (
        <div style={{ marginTop: 12 }}>
          {users.map((user) => (
            <Text
              mt={4}
              as="P2"
              bold
              style={{ color: "#232C2E" }}
              key={user.uid}
            >
              {user.displayName}
            </Text>
          ))}
          <div
            onClick={() => {
              if (isPlay) {
                onOpenTeeTime();
              }
              if (!isPlay && alredyPlayInDifrentTeeTime) {
                // eslint-disable-next-line no-console
                console.info("Alredy play in difrent TeeTime");
              }
              if (!isPlay && !alredyPlayInDifrentTeeTime) {
                onJoinTeeTime();
              }
            }}
            aria-hidden
            style={{
              marginTop: 12,
              // eslint-disable-next-line no-nested-ternary
              backgroundColor: isPlay
                ? "#FFA340"
                : individualIsFull
                ? "#EDEFEF"
                : "#379FDC",
              borderRadius: 8,
              width: "max-content",
              paddingLeft: 8,
              paddingRight: 8,
              minWidth: 74,
              height: 38,
              display: "grid",
              placeItems: "center",
            }}
          >
            <Text
              style={{
                color: "white",
                fontWeight: 800,
                fontSize: 13,
              }}
            >
              {individualPlayButtonTitle()}
            </Text>
          </div>
        </div>
      )}
    </div>
  );
}

export { CardEvent2 };

CardEvent2.propTypes = {
  teeTimeString: PropTypes.string.isRequired,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      length: PropTypes.number,
    }),
  ),
  isPlay: PropTypes.bool,
  teams: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      name: PropTypes.string,
      teamId: PropTypes.string,
      teamSize: PropTypes.number,
      users: PropTypes.arrayOf(
        PropTypes.shape({
          courseHandicap: PropTypes.number,
          displayName: PropTypes.string,
          holes: PropTypes.arrayOf(PropTypes.shape({})),
          phone: PropTypes.string,
          quota: PropTypes.number,
          timestamp: PropTypes.shape({
            seconds: PropTypes.number,
            nanoseconds: PropTypes.number,
          }),
          uid: PropTypes.string,
        }),
      ),
    }),
  ]),
  matchPlay: PropTypes.bool,
  // onJointTeam: PropTypes.func.isRequired,
  // onJointTeeTime: PropTypes.func.isRequired,
};

CardEvent2.defaultProps = {
  users: [],
  teams: [],
  isPlay: false,
  matchPlay: false,
};
